<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card>
            <template slot="header">
              <div class="row">
                <div class="col">
                  <h4 class="card-title">Banners</h4>
                  <p class="card-category">Spotlight &amp; Cause Banners</p>
                </div>
                <div class="col">
                  <form class="form-inline justify-content-end">
                    <button class="btn" @click.prevent="onNewBanner()">New Banner</button>
                  </form>
                </div>
              </div>
            </template>
            <div>
              <el-input placeholder="Filter by ..." v-model="filter.text" class="input-with-select">
                <el-select v-model="filter.by" slot="prepend" placeholder="Select">
                  <el-option label="Name" value="name"></el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </div>
            <el-table
              class="itf-table"
              :data="filteredData"
              style="width: 100%"
              :stripe="true"
              empty-text="No Data"
              >
              <el-table-column label="" width="80">
                <template slot-scope="scope">
                  <button type="button" class="btn btn-icon btn-primary" @click="onEditBanner(scope.row)"><i class="nc-icon nc-file-edit"></i></button>
                  <button type="button" class="btn btn-icon btn-danger" @click="onDeleteBanner(scope.row)"><i class="nc-icon nc-simple-remove"></i></button>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="Name" width="180">
                <template slot-scope="scope">
                  <router-link :to="'/me/admin/banner/' + scope.row.id">{{scope.row.name}}</router-link>
                </template>
              </el-table-column>
              <el-table-column prop="email" label="Owner" width="180">
                <template slot-scope="scope">
                  <span v-text="ownerName(scope.row)"></span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="Banner" width="180">
                <template slot-scope="scope">
                  Banner TODO
                </template>
              </el-table-column>
            </el-table>
            <!-- <button class="btn btn-primary">some button</button> -->
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { computed, reactive, ref, onMounted } from '@vue/composition-api'
import graphql from '@/api/graphql'
import gql from 'graphql-tag'
import router from '@/routes/router'
import BaseRadio from '../../components/Forms/BaseRadio.vue'

export default {
  components: { BaseRadio },
  setup(props, context) {
    const root = context.root
    const store = root.$store
    const tableData = ref([])
    let profile = store.state.users.profile

    onMounted(() => {
      let graphQuery = gql`{
        bannerList {
          id
          name
          bannerUrl
          email
          firstName
          lastName
        }
      }`
      graphql.query(graphQuery)
        .then(json => {
          tableData.value = json.data.bannerList
        })
        .catch(gqlResponse => {
          graphql.handleError(gqlResponse, 'Error getting banner list:', store.dispatch)
        })
    })

    // Text Filter
    const filter = reactive({
      by: 'name',
      text: ''
    })
    const filteredData = computed(() => {
      return tableData.value.filter(item => {
        let filterText = filter.text.toLowerCase()
        if (filterText == '') {
          return true
        }
        return item.name.toLowerCase().includes(filterText)
      })
    })
    const hasFilteredData = computed(() => {
      var result = filteredData.value.length > 0
      // console.log('hasFilteredData', filteredData.value, result)
      return result
    })

    function ownerName(row) {
      if (row.email == profile.email) {
        return 'Me'
      }
      return row.firstName + ' ' + row.lastName
    }

    function onNewBanner() {
      // console.log('new banner click')
      router.push(`${process.env.BASE_URL}admin/banner/new`)
    }

    function onEditBanner(row) {
      // console.log('edit banner click', row)
      router.push(`${process.env.BASE_URL}admin/banner/` + row.id)
    }

    // Delete Dialog
    function onDeleteBanner(row) {
      root.$confirm("This will permanently delete '" + row.name + "'. Continue?", "Warning", {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        let graphQuery = gql`mutation BannerDelete($id: ID!) {
          bannerDelete(id: $id) {
            id
            name
            bannerUrl
            email
            firstName
            lastName
          }
        }`
        graphql.query(graphQuery, {
          id: row.id
        })
        .then(json => {
          tableData.value = json.data.bannerDelete
          store.dispatch('notify', { type: 'success', message: 'Banner deleted'})
        })
        .catch(gqlResponse => {
          graphql.handleError(gqlResponse, 'Error deleting Banner:', store.dispatch)
        })
      })
    }



    // setup return
    return {
      filter,
      filteredData,
      hasFilteredData,
      ownerName,
      onNewBanner,
      onEditBanner,
      onDeleteBanner
    }
  },
  filters: {
    formatCountry: function (value) {
      if (!value) return ''
      if (value.includes('Korea')) {
        return 'South Korea'
      }
      return value
    }
  }
}
</script>
<style lang="scss">
  .el-select .el-input {
    width: 110px;
  }
</style>